import { useState } from "react";
import { motion } from "framer-motion";
import SectionTitle from "../ui/SectionTitle";
import projects from "../../data/projects";
import {
  FaArrowRight,
  FaExternalLinkAlt,
} from "react-icons/fa";

// const filters = [
//   "All",
//   "React",
//   "Next.js",
//   "WordPress",
// ];

export default function Projects() {

  const [active, setActive] = useState("All");

  const filtered =
    active === "All"
      ? projects
      : projects.filter(
          (item) => item.category === active
        );

  return (
    <section
      id="projects"
      className="section bg-[#050816]"
    >
      <div className="container">

        <SectionTitle
          subtitle="Portfolio"
          title="Featured Projects"
        />

        <div className="max-w-3xl">

          <p className="text-slate-400 leading-8 text-lg">

            A selection of websites and web
            applications developed for startups,
            agencies and businesses around the
            world using React, Next.js,
            WordPress and modern frontend
            technologies.

          </p>

        </div>

        {/* Filters */}

        {/* <div className="flex flex-wrap gap-4 mt-14 mb-16">

          {filters.map((item) => (

            <button
              key={item}
              onClick={() => setActive(item)}
              className={`px-7 py-3 rounded-full transition

              ${
                active === item
                  ? "bg-blue-600"
                  : "bg-white/5 hover:bg-white/10"
              }

              `}
            >

              {item}

            </button>

          ))}

        </div> */}

        {/* Grid */}

        <div className="grid gap-8 lg:grid-cols-2 xl:grid-cols-3 mt-10">

          {filtered.map((project, index) => (

            <motion.div

              key={project.id}

              initial={{
                opacity:0,
                y:40
              }}

              whileInView={{
                opacity:1,
                y:0
              }}

              transition={{
                delay:index*.08
              }}

              viewport={{
                once:true
              }}

              className="group rounded-3xl overflow-hidden border border-white/10 bg-white/5"

            >

              {/* Image */}

              <div className="relative overflow-hidden">

                <img

                  src={project.image}

                  alt={project.title}

                  className="h-72 w-full object-cover transition duration-700 group-hover:scale-110"

                />

                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-70" />

              </div>

              {/* Content */}

              <div className="p-8">

                <span className="text-blue-400 text-sm uppercase tracking-[3px]">

                  {project.category}

                </span>

                <h3 className="mt-4 text-2xl font-bold">

                  {project.title}

                </h3>

                <p className="mt-5 leading-8 text-slate-400">

                  {project.description}

                </p>

                {/* Tech */}

                <div className="flex flex-wrap gap-3 mt-8">

                  {project.technologies.map((tech) => (

                    <span

                      key={tech}

                      className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm"

                    >

                      {tech}

                    </span>

                  ))}

                </div>

                {/* Button */}

                {/* <a

                  href={project.live}

                  className="mt-8 inline-flex items-center gap-3 text-blue-400 hover:text-blue-300"

                >

                  View Project

                  <FaExternalLinkAlt />

                </a> */}

              </div>

            </motion.div>

          ))}

        </div>

        {/* Bottom CTA */}

        <div className="mt-24 text-center">

          <h3 className="text-4xl font-bold">

            More than 1000 websites delivered

          </h3>

          <p className="mt-6 text-slate-400 max-w-3xl mx-auto leading-8">

            My portfolio includes corporate websites,
            ecommerce stores, landing pages,
            headless WordPress applications,
            React dashboards, and enterprise
            web applications for clients worldwide.

          </p>

          <a

            href="#contact"

            className="inline-flex items-center gap-4 bg-blue-600 px-8 py-4 rounded-xl mt-10 hover:bg-blue-700"

          >

            Let's Build Yours

            <FaArrowRight />

          </a>

        </div>

      </div>
    </section>
  );
}